export default __webpack_public_path__ + "static/media/go_sound_oneshot.f1797680.mp3";